

























































import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import Vue from 'vue';

import SubjectConfirmMixins from './mixins';

@Component
export default class SubjectConfirmPage extends mixins(Vue, SubjectConfirmMixins) {}
